import React from 'react'
import common from '../methods/common'
import CONSTANTS from '../CONSTANTS'

const Downloads = () => {
    let data = CONSTANTS.documentsConfigs
    return (
        <div className='download df-jc'>
            <div className='download-section'>
                <h3 className='title'>Download Section</h3>
                {data.map(item => {
                    return <ul className=''>
                        <li className='df'>
                            <p>{item.displayName} - </p>
                            <p className='link'><span onClick={() => common.openInNewTab(item.url)}>(Download) </span></p>
                        </li>
                    </ul>
                })}
            </div>
        </div>
    )
}

export default Downloads
